import requestor from "requestor";
import BaseRoute from "utils/base_route";
import getRouteIds from "utils/get_route_ids";

import matterFetchAction from "modules/matters/actions/fetch_matter";
import clearMatterAction from "modules/matters/actions/clear_matter";
import MatterDocumentContainer from "./containers/matter_document";

export default class MatterDocumentRoute extends BaseRoute {
  constructor(store, path) {
    super(path, store);
  }

  getComponents(location, cb) {
    cb(null, MatterDocumentContainer);
  }

  fetchActiveData(props) {
    const {organisationId, projectId, matterId} = getRouteIds(props.router);
    this.fetchMatter(organisationId, projectId, matterId);
  }

  fetchMatter(organisationId, projectId, matterId) {
    this.store.dispatch(
      matterFetchAction(requestor)(organisationId, projectId, matterId),
    );
  }

  clearActiveData() {
    this.store.dispatch(clearMatterAction());
  }
}
